import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Checklist extends Base {
  /**C
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/checklist?" + queryParam);
    return this._secureFetch(url);
  }
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */

  getOne(id) {
    const url = this._getFullURL("/cmms/checklist/" + id);
    return this._secureFetch(url);
  }




  create(payload) {
    const url = this._getFullURL("/cmms/checklist");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  update(id, payload) {
    const url = this._getFullURL("/cmms/checklist/" + id);
    return fetch(url, this._generateRequestBody({ payload, method: "PUT" }));
    
  }

  delete = (id) => {
    const url = this._getFullURL(`/cmms/checklist/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };

  import(payload) {
    const url = this._getFullURL(`/cmms/checklist/import`);

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }


}
